import { render, staticRenderFns } from "./ModuleInstall.vue?vue&type=template&id=fe295b6e&scoped=true"
import script from "./ModuleInstall.vue?vue&type=script&lang=js"
export * from "./ModuleInstall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe295b6e",
  null
  
)

export default component.exports